

// import React, { useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   Alert,
//   CssBaseline,
//   InputAdornment,
//   IconButton,
//   CircularProgress,
//   Checkbox,
//   FormControlLabel,
//   Dialog,
//   DialogTitle,
//   DialogContent,
// } from "@mui/material";
// import {
//   Visibility,
//   VisibilityOff,
//   Close,
//   Lock,
//   Person,
// } from "@mui/icons-material";
// import AuraVideo from "../assets/3.mp4";
// import { keyframes } from "@mui/system";

// const pulseLogo = keyframes`
//   0% { transform: scale(1); filter: drop-shadow(0 0 10px white); }
//   50% { transform: scale(1.1); filter: drop-shadow(0 0 20px white); }
//   100% { transform: scale(1); filter: drop-shadow(0 0 10px white); }
// `;

// export default function Login() {
//   const [form, setForm] = useState({ username: "", password: "" });
//   const [errorMessage, setErrorMessage] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [rememberMe, setRememberMe] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [dialogStage, setDialogStage] = useState(1);
//   const [email, setEmail] = useState("");
//   const [generatedOtp, setGeneratedOtp] = useState("");
//   const [otp, setOtp] = useState("");
//   const [newPassword, setNewPassword] = useState("");
//   const [dialogMessage, setDialogMessage] = useState("");
//   const navigate = useNavigate();

//   const checkUserExists = async (email) => {
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/User/checkuserexists?email=${email}`
//       );
//       return response.data;
//     } catch (error) {
//       setDialogMessage("The given email is not registered");
//       return false;
//     }
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     setIsLoading(true);

//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_BASE_URL}/Login/Login`,
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(form),
//         }
//       );

//       if (!response.ok) {
//         const errorMessage = await response.text();
//         setErrorMessage(
//           errorMessage.includes("Invalid username")
//             ? "Invalid username. Please check and try again."
//             : errorMessage.includes("Invalid password")
//             ? "Invalid password. Please check and try again."
//             : `Login failed: ${errorMessage}`
//         );
//         setIsLoading(false);
//         return;
//       }

//       const data = await response.json();
//       localStorage.setItem("Token", data.Token);
//       localStorage.setItem("Role", data.Role);
//       localStorage.setItem("Name", data.Name);
//       localStorage.setItem("Email", data.Email);
//       localStorage.setItem("isLoggedIn", "true");

//       if (rememberMe) {
//         localStorage.setItem("username", form.username);
//         localStorage.setItem("password", form.password);
//         localStorage.setItem("rememberMe", "true");
//       } else {
//         localStorage.removeItem("username");
//         localStorage.removeItem("password");
//         localStorage.removeItem("rememberMe");
//       }

//       navigate("/dashboard");
//     } catch (error) {
//       setErrorMessage("Network error. Please try again.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({ ...prev, [name]: value }));
//     if (errorMessage) setErrorMessage("");
//   };

//   const handleForgotPassword = () => {
//     setOpenDialog(true);
//     setDialogStage(1);
//     setEmail("");
//     setDialogMessage("");
//   };

//   const handleDialogClose = () => {
//     setOpenDialog(false);
//     setDialogStage(1);
//     setEmail("");
//     setOtp("");
//     setNewPassword("");
//     setDialogMessage("");
//   };

//   const sendResetOTP = async () => {
//     if (!email) {
//       setDialogMessage("Please enter your email address");
//       return;
//     }

//     const userExists = await checkUserExists(email);
//     if (!userExists) return;

//     try {
//       const otpCode = Math.floor(100000 + Math.random() * 900000);
//       setGeneratedOtp(otpCode.toString());
//       setDialogMessage("OTP sent to your email address");
//       setDialogStage(2);
//     } catch (error) {
//       setDialogMessage("Failed to send OTP. Please try again.");
//     }
//   };

//   const verifyOTPAndResetPassword = async () => {
//     if (otp !== generatedOtp) {
//       setDialogMessage("Invalid OTP. Please try again.");
//       return;
//     }

//     if (!newPassword || newPassword.length < 6) {
//       setDialogMessage("Password must be at least 6 characters long");
//       return;
//     }

//     try {
//       await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/User/resetpassword`,
//         { email, newPassword }
//       );
//       setDialogMessage(
//         "Password reset successful! You can now login with your new password."
//       );
//       setTimeout(() => handleDialogClose(), 2000);
//     } catch (error) {
//       setDialogMessage("Failed to reset password. Please try again.");
//     }
//   };

//   return (
//     <>
//       <CssBaseline />
//       <Box
//         sx={{
//           position: "relative",
//           height: "100vh",
//           width: "100vw",
//           overflow: "hidden",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//         }}
//       >
//         {/* 🎥 Video Background */}
//         <video
//           autoPlay
//           loop
//           muted
//           playsInline
//           style={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             minWidth: "100%",
//             minHeight: "100%",
//             transform: "translate(-50%, -50%)",
//             objectFit: "cover",
//             zIndex: -2,
//           }}
//         >
//           <source src={AuraVideo} type="video/mp4" />
//         </video>

//         {/* Overlay */}
//         <Box
//           sx={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             backgroundColor: "rgba(0, 0, 0, 0.4)",
//             zIndex: -1,
//           }}
//         />

//         {/* Centered Login Box */}
//         <Box
//           sx={{
//             position: "relative",
//             zIndex: 1,
//             width: "100%",
//             maxWidth: 450,
//             mx: "auto",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             minHeight: "100vh",
//             px: 3,
//           }}
//         >
//           <Box
//             sx={{
//               p: { xs: 4, md: 5 },
//               display: "flex",
//               flexDirection: "column",
//               justifyContent: "center",
//               alignItems: "center",
//               width: "100%",
//               backgroundColor: "rgba(255, 255, 255, 0.15)",
//               backdropFilter: "blur(20px) saturate(150%)",
//               border: "1px solid rgba(255, 255, 255, 0.3)",
//               borderRadius: 4,
//               boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
//               color: "white",
//               textAlign: "center",
//             }}
//           >
//             <Box
//               component="img"
//               src={require("../assets/saloonlogo.png")}
//               alt="Logo"
//               sx={{
//                 width: { xs: 150, sm: 180, md: 200 },
//                 mb: 3,
//                 animation: `${pulseLogo} 3s infinite ease-in-out`,
//                 filter: `
//                   drop-shadow(0 0 8px white)
//                   drop-shadow(0 0 16px white)
//                   drop-shadow(0 0 24px rgba(149, 117, 205, 1))
//                 `,
//               }}
//             />

//             {errorMessage && (
//               <Alert severity="error" sx={{ width: "100%", mb: 2 }}>
//                 {errorMessage}
//               </Alert>
//             )}

//             <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
//               {/* Username Field */}
//               <TextField
//                 fullWidth
//                 id="username"
//                 label="Username"
//                 name="username"
//                 variant="outlined"
//                 value={form.username}
//                 onChange={handleInputChange}
//                 sx={{
//                   mb: 2,
//                   "& .MuiOutlinedInput-root": {
//                     "& fieldset": { borderColor: "rgba(255,255,255,0.5)" },
//                     "&:hover fieldset": { borderColor: "white" },
//                     "& input": { color: "white" },
//                   },
//                   "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.8)" },
//                 }}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Person sx={{ color: "white" }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 InputLabelProps={{ style: { color: "white" } }}
//               />

//               {/* Password Field */}
//               <TextField
//                 fullWidth
//                 id="password"
//                 label="Password"
//                 name="password"
//                 type={showPassword ? "text" : "password"}
//                 variant="outlined"
//                 value={form.password}
//                 onChange={handleInputChange}
//                 sx={{
//                   mb: 2,
//                   "& .MuiOutlinedInput-root": {
//                     "& fieldset": { borderColor: "rgba(255,255,255,0.5)" },
//                     "&:hover fieldset": { borderColor: "white" },
//                     "& input": { color: "white" },
//                   },
//                   "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.8)" },
//                 }}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Lock sx={{ color: "white" }} />
//                     </InputAdornment>
//                   ),
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton
//                         onClick={() => setShowPassword(!showPassword)}
//                         edge="end"
//                         sx={{ color: "white" }}
//                       >
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//                 InputLabelProps={{ style: { color: "white" } }}
//               />

//               <FormControlLabel
//                 control={
//                   <Checkbox
//                     checked={rememberMe}
//                     onChange={(e) => setRememberMe(e.target.checked)}
//                     name="rememberMe"
//                     sx={{ color: "white" }}
//                   />
//                 }
//                 label="Remember me"
//                 sx={{ color: "white", mb: 2 }}
//               />

//               <Button
//                 type="submit"
//                 fullWidth
//                 variant="contained"
//                 disabled={isLoading}
//                 sx={{
//                   mb: 2,
//                   py: 1.5,
//                   fontSize: "1.1rem",
//                   fontWeight: "bold",
//                   borderRadius: 2,
//                   background: "linear-gradient(45deg, #42a5f5, #1e88e5)",
//                   boxShadow: "0 0 10px rgba(66,165,245,0.6)",
//                   "&:hover": {
//                     background: "linear-gradient(45deg, #1e88e5, #1565c0)",
//                     boxShadow: "0 0 15px rgba(66,165,245,0.8)",
//                   },
//                 }}
//               >
//                 {isLoading ? (
//                   <CircularProgress size={24} color="inherit" />
//                 ) : (
//                   "Sign In"
//                 )}
//               </Button>

//               <Button
//                 fullWidth
//                 variant="text"
//                 onClick={handleForgotPassword}
//                 sx={{
//                   color: "white",
//                   textDecoration: "underline",
//                   "&:hover": { color: "#90caf9" },
//                 }}
//               >
//                 Forgot Password?
//               </Button>
//             </Box>
//           </Box>
//         </Box>
//       </Box>

//       {/* Password Reset Dialog */}
//       <Dialog open={openDialog} onClose={handleDialogClose} maxWidth="sm" fullWidth>
//         <DialogTitle>
//           Reset Password
//           <IconButton
//             onClick={handleDialogClose}
//             sx={{ position: "absolute", right: 8, top: 8 }}
//           >
//             <Close />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent>
//           {dialogStage === 1 && (
//             <Box sx={{ pt: 2 }}>
//               <TextField
//                 fullWidth
//                 type="email"
//                 label="Email Address"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 sx={{ mb: 3 }}
//               />
//               <Button fullWidth variant="contained" onClick={sendResetOTP}>
//                 Send OTP
//               </Button>
//             </Box>
//           )}

//           {dialogStage === 2 && (
//             <Box sx={{ pt: 2 }}>
//               <TextField
//                 fullWidth
//                 label="Enter OTP"
//                 value={otp}
//                 onChange={(e) => setOtp(e.target.value)}
//                 sx={{ mb: 3 }}
//               />
//               <TextField
//                 fullWidth
//                 type="password"
//                 label="New Password"
//                 value={newPassword}
//                 onChange={(e) => setNewPassword(e.target.value)}
//                 sx={{ mb: 3 }}
//               />
//               <Button fullWidth variant="contained" onClick={verifyOTPAndResetPassword}>
//                 Reset Password
//               </Button>
//             </Box>
//           )}

//           {dialogMessage && (
//             <Alert
//               severity={
//                 dialogMessage.includes("successful") ? "success" : "error"
//               }
//               sx={{ mt: 2 }}
//             >
//               {dialogMessage}
//             </Alert>
//           )}
//         </DialogContent>
//       </Dialog>
//     </>
//   );
// }


import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  TextField,
  Typography,
  Alert,
  CssBaseline,
  InputAdornment,
  IconButton,
  CircularProgress,
  Checkbox,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import {
  Visibility,
  VisibilityOff,
  Close,
  Lock,
  Person,
} from "@mui/icons-material";
import AuraVideo from "../assets/3.mp4";
import { keyframes } from "@mui/system";

const pulseLogo = keyframes`
  0% { transform: scale(1); filter: drop-shadow(0 0 10px white); }
  50% { transform: scale(1.1); filter: drop-shadow(0 0 20px white); }
  100% { transform: scale(1); filter: drop-shadow(0 0 10px white); }
`;

export default function Login() {
  const [form, setForm] = useState({ username: "", password: "" });
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogStage, setDialogStage] = useState(1);
  const [email, setEmail] = useState("");
  const [generatedOtp, setGeneratedOtp] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [dialogMessage, setDialogMessage] = useState("");
  const navigate = useNavigate();

  const checkUserExists = async (email) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/User/checkuserexists?email=${email}`
      );
      return response.data;
    } catch (error) {
      setDialogMessage("The given email is not registered");
      return false;
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/Login/Login`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        }
      );

      if (!response.ok) {
        const errorMessage = await response.text();
        setErrorMessage(
          errorMessage.includes("Invalid username")
            ? "Invalid username. Please check and try again."
            : errorMessage.includes("Invalid password")
            ? "Invalid password. Please check and try again."
            : `Login failed: ${errorMessage}`
        );
        setIsLoading(false);
        return;
      }

      const data = await response.json();

      // ✅ Save login details in localStorage
      localStorage.setItem("Token", data.Token);
      localStorage.setItem("Role", data.Role);
      localStorage.setItem("Name", data.Name);
      localStorage.setItem("Email", data.Email || "");
      localStorage.setItem("id", data.id); // <---- NEW LINE: save user ID
      localStorage.setItem("isLoggedIn", "true");

      // ✅ Handle Remember Me
      if (rememberMe) {
        localStorage.setItem("username", form.username);
        localStorage.setItem("password", form.password);
        localStorage.setItem("rememberMe", "true");
      } else {
        localStorage.removeItem("username");
        localStorage.removeItem("password");
        localStorage.removeItem("rememberMe");
      }

      // ✅ Redirect after successful login
      navigate("/dashboard");
    } catch (error) {
      setErrorMessage("Network error. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (errorMessage) setErrorMessage("");
  };

  const handleForgotPassword = () => {
    setOpenDialog(true);
    setDialogStage(1);
    setEmail("");
    setDialogMessage("");
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setDialogStage(1);
    setEmail("");
    setOtp("");
    setNewPassword("");
    setDialogMessage("");
  };

  const sendResetOTP = async () => {
    if (!email) {
      setDialogMessage("Please enter your email address");
      return;
    }

    const userExists = await checkUserExists(email);
    if (!userExists) return;

    try {
      const otpCode = Math.floor(100000 + Math.random() * 900000);
      setGeneratedOtp(otpCode.toString());
      setDialogMessage("OTP sent to your email address");
      setDialogStage(2);
    } catch (error) {
      setDialogMessage("Failed to send OTP. Please try again.");
    }
  };

  const verifyOTPAndResetPassword = async () => {
    if (otp !== generatedOtp) {
      setDialogMessage("Invalid OTP. Please try again.");
      return;
    }

    if (!newPassword || newPassword.length < 6) {
      setDialogMessage("Password must be at least 6 characters long");
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/User/resetpassword`,
        { email, newPassword }
      );
      setDialogMessage(
        "Password reset successful! You can now login with your new password."
      );
      setTimeout(() => handleDialogClose(), 2000);
    } catch (error) {
      setDialogMessage("Failed to reset password. Please try again.");
    }
  };

  return (
    <>
      <CssBaseline />
      <Box
        sx={{
          position: "relative",
          height: "100vh",
          width: "100vw",
          overflow: "hidden",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* 🎥 Video Background */}
        <video
          autoPlay
          loop
          muted
          playsInline
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            minWidth: "100%",
            minHeight: "100%",
            transform: "translate(-50%, -50%)",
            objectFit: "cover",
            zIndex: -2,
          }}
        >
          <source src={AuraVideo} type="video/mp4" />
        </video>

        {/* Overlay */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            zIndex: -1,
          }}
        />

        {/* Login Box */}
        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            width: "100%",
            maxWidth: 450,
            mx: "auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            px: 3,
          }}
        >
          <Box
            sx={{
              p: { xs: 4, md: 5 },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              backgroundColor: "rgba(255, 255, 255, 0.15)",
              backdropFilter: "blur(20px) saturate(150%)",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              borderRadius: 4,
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
              color: "white",
              textAlign: "center",
            }}
          >
            <Box
              component="img"
              src={require("../assets/saloonlogo.png")}
              alt="Logo"
              sx={{
                width: { xs: 150, sm: 180, md: 200 },
                mb: 3,
                animation: `${pulseLogo} 3s infinite ease-in-out`,
                filter: `
                  drop-shadow(0 0 8px white)
                  drop-shadow(0 0 16px white)
                  drop-shadow(0 0 24px rgba(149, 117, 205, 1))
                `,
              }}
            />

            {errorMessage && (
              <Alert severity="error" sx={{ width: "100%", mb: 2 }}>
                {errorMessage}
              </Alert>
            )}

            <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
              {/* Username */}
              <TextField
                fullWidth
                id="username"
                label="Username"
                name="username"
                variant="outlined"
                value={form.username}
                onChange={handleInputChange}
                sx={{
                  mb: 2,
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: "rgba(255,255,255,0.5)" },
                    "&:hover fieldset": { borderColor: "white" },
                    "& input": { color: "white" },
                  },
                  "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.8)" },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Person sx={{ color: "white" }} />
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{ style: { color: "white" } }}
              />

              {/* Password */}
              <TextField
                fullWidth
                id="password"
                label="Password"
                name="password"
                type={showPassword ? "text" : "password"}
                variant="outlined"
                value={form.password}
                onChange={handleInputChange}
                sx={{
                  mb: 2,
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: "rgba(255,255,255,0.5)" },
                    "&:hover fieldset": { borderColor: "white" },
                    "& input": { color: "white" },
                  },
                  "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.8)" },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Lock sx={{ color: "white" }} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                        sx={{ color: "white" }}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{ style: { color: "white" } }}
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                    name="rememberMe"
                    sx={{ color: "white" }}
                  />
                }
                label="Remember me"
                sx={{ color: "white", mb: 2 }}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={isLoading}
                sx={{
                  mb: 2,
                  py: 1.5,
                  fontSize: "1.1rem",
                  fontWeight: "bold",
                  borderRadius: 2,
                  background: "linear-gradient(45deg, #42a5f5, #1e88e5)",
                  boxShadow: "0 0 10px rgba(66,165,245,0.6)",
                  "&:hover": {
                    background: "linear-gradient(45deg, #1e88e5, #1565c0)",
                    boxShadow: "0 0 15px rgba(66,165,245,0.8)",
                  },
                }}
              >
                {isLoading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Sign In"
                )}
              </Button>

              <Button
                fullWidth
                variant="text"
                onClick={handleForgotPassword}
                sx={{
                  color: "white",
                  textDecoration: "underline",
                  "&:hover": { color: "#90caf9" },
                }}
              >
                Forgot Password?
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Password Reset Dialog */}
      <Dialog open={openDialog} onClose={handleDialogClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          Reset Password
          <IconButton
            onClick={handleDialogClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {dialogStage === 1 && (
            <Box sx={{ pt: 2 }}>
              <TextField
                fullWidth
                type="email"
                label="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                sx={{ mb: 3 }}
              />
              <Button fullWidth variant="contained" onClick={sendResetOTP}>
                Send OTP
              </Button>
            </Box>
          )}

          {dialogStage === 2 && (
            <Box sx={{ pt: 2 }}>
              <TextField
                fullWidth
                label="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                sx={{ mb: 3 }}
              />
              <TextField
                fullWidth
                type="password"
                label="New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                sx={{ mb: 3 }}
              />
              <Button fullWidth variant="contained" onClick={verifyOTPAndResetPassword}>
                Reset Password
              </Button>
            </Box>
          )}

          {dialogMessage && (
            <Alert
              severity={
                dialogMessage.includes("successful") ? "success" : "error"
              }
              sx={{ mt: 2 }}
            >
              {dialogMessage}
            </Alert>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
